import useSimplePages from "@/hooks/useSimplePages";
import { useState } from "react";

export const useSimplePage = (url_slug) => {
  const pages = useSimplePages();
  const [page] = useState(pages.find((p) => p.url_slug === url_slug));

  return page;
};

export default useSimplePage;
